export const getAuthProfile = state => state.auth.authProfile;
export const getSecondData = state => state.auth.secondData;
export const getStartUrl = state => state.auth.startUrl;
export const getAuthStatus = state => state.auth.authStatus;